// extracted by mini-css-extract-plugin
export default {"app":"AppLayout_app__Ov0wG"};